module.exports = __webpack_public_path__ + "img/lang-fr.bd749f07.png";